export default {
    formId: "CarForm",
    formField: {
        //FIRST FORM
        name: {
            name: 'name',
            label: 'Nombre',
            requiredErrorMsg: 'Por favor, ingrese su nombre'
        },
       lastName: {
            name: 'lastName',
            label: 'Apellido',
            requiredErrorMsg: 'Por favor, ingrese su apellido'
        },
        email: {
            name: 'email',
            label: 'Email',
            requiredErrorMsg: 'Por favor, ingrese su email'
        },
        phone: {
            name: 'phone',
            label: 'Celular',
            requiredErrorMsg: 'Por favor, ingrese su celular'
        },
        postCode: {
            name: 'postCode',
            label: 'Código Postal',
            requiredErrorMsg: 'Por favor, ingrese su código postal',
            invalidErrorMsg: 'Código postal inválido'
        },
        dni: {
            name: 'dni',
            label: 'DNI',
            requiredErrorMsg: 'Por favor, ingrese su número de documento',
            invalidErrorMsg: 'DNI inválido'
        },
        //SECOND FORM
        vehiculo: {
            marca: {
                name: 'vehiculo.marca',
                label: 'Marca',
                requiredErrorMsg: 'Por favor, ingrese la marca del vehículo',
            },
            anio: {
                name: 'vehiculo.anio',
                label: 'Año',
                requiredErrorMsg: 'Por favor, ingrese el año del vehículo',
                invalidErrorMsg: 'Año inválido (2000 en adelante)'
            },
            modelo: {
                name: 'vehiculo.modelo',
                label: 'Modelo',
                requiredErrorMsg: 'Por favor, ingrese el modelo',
            },
            version: {
                name: 'vehiculo.version',
                label: 'Versión',
                requiredErrorMsg: 'Por favor, ingrese la versión del vehículo',
            },
            patente: {
                name: 'vehiculo.patente',
                label: 'Patente',
            },
            tieneGnc: {
                name: 'vehiculo.tieneGnc',
                label: '¿Tiene equipo de GNC?',
                requiredErrorMsg: 'Por favor, indique si el vehículo tiene equipo de GNC',
            },
            valorGnc: {
                name: 'vehiculo.valorGnc',
                label: 'Valor del equipo de GNC',
                requiredErrorMsg: 'Debe ingresar el valor del equipo de GNC'
            },
            adtValue: {
                name: 'vehiculo.adtValue',
                label: 'Valor adicional',
            },
        },
        //THIRD FORM
        carProdSelected: {
            name: 'carProdSelected',
            requiredErrorMsg: 'Por favor, seleccione una opción',
        },
        comments: {
            name: 'comments',
        },
        uploadedFile: {
            name: 'uploadedFile',
        },
    },
};
